<div class="component-main-container">
  <div class="header">
    <app-page-header parentTitle="{{'division.parentTitle' | translate}}"
      pageTitle="{{'division.pageTitle' | translate}}"></app-page-header>
  </div>
  <div class="row">
    <div class="col-lg-5 col-xl-4 col-sm-1">
      <div class="component-forms-box">
        <app-register-form></app-register-form>

        <!-- REGISTRO DE DIVISÃO -->
        <div class="form-fields-box" [ngClass]="!registerBoxOpen ? 'closed' : ''" [formGroup]="registerForm">
          <h2 (click)="registerBox()"> {{"division.register-form" | translate}}</h2>
          <hr [ngClass]="!registerBoxOpen ? 'hr-open' : ''">
          <div class="form-step">
            <div class="circle-number"> 1 </div>
            <mat-form-field appearance="outline">
              <mat-label> {{"division.register-form-reference" | translate}} </mat-label>
              <input matInput formControlName="reference">
            </mat-form-field>
          </div>
          <!-- Botões de registro -->
          @if (!createLoading) {
          <button class="btn btn-success" (click)="registerDivision()">
            {{"division.button-save" | translate}}
          </button>
          }
          @if (createLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>

        <!-- FILTRO DE DIVISÃO -->
        <div class="form-fields-box" [ngClass]="!filterBoxOpen ? 'closed' : ''" [formGroup]="filterForm">
          <h2 (click)="filterBox()"> {{"division.filter-form" | translate}} </h2>
          <hr [ngClass]="!filterBoxOpen ? 'hr-open' : ''">

          <div class="form-step">
            <div class="circle-number"> 1 </div>
            <mat-form-field appearance="outline">
              <mat-label> {{"division.filter-form-reference" | translate}} </mat-label>
              <input matInput formControlName="reference">
            </mat-form-field>
          </div>

          <!-- Botões de filtro -->
          @if (!filterLoading) {
          <button class="btn btn-success" (click)="filterDivision(null)">
            {{"division.button-filter" | translate}}
          </button>
          }
          @if (filterLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
      </div>
    </div>

    <!-- TABELA -->
    @if (paginationProperties.total) {
    <div class="col-lg-7 col-xl-8 col-sm-12">
      @if (length > 0) {
      <app-table-header [itensNumber]="paginationProperties.count" [totalNumber]="paginationProperties.total"
        [hasCSV]="true" [hasPDF]="true" [loadingData$]="fileLoading" (downloadCSV)="generateFileData(null, 'CSV')"
        (downloadPDF)="generateFileData(null, 'PDF')">
      </app-table-header>
      }
      @if (ELEMENT_DATA.length) {
      <div class="table-container mt-2 mt-lg-3">
        <p-table [value]="ELEMENT_DATA" dataKey="id" [paginator]="true" [rows]="pageSize" [totalRecords]="length"
          (onPage)="pageChanged($event)" [showPageLinks]="false" [showFirstLastIcon]="false" [lazy]="true">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="reference">{{"division.column-reference" | translate}} </th>
              <th pSortableColumn="actions">{{"division.column-actions" | translate}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              <td>{{row.reference}}</td>
              <td>
                <!-- Botão de edição -->
                <p-button (click)="openSidebarUpdate(row, false)" styleClass="btn-actions" [rounded]="true"
                  icon="pi pi-pen-to-square" />
                <!-- Botão de Visualização -->
                <p-button (click)="openSidebarUpdate(row, true)" styleClass="btn-view" [rounded]="true"
                  icon="pi pi-eye" />
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      }
    </div>
    }
    @if (editorController) {
    <div class="sidebar-edit" [formGroup]="updateForm">
      <mat-icon class="close-sidebar" (click)="closeEditSidebar()">clear</mat-icon>
      @if (!viewController) {
      <h2> {{"division.edit-form" | translate}} </h2>
      }
      @if (viewController) {
      <h2> {{"division.view-form" | translate}} </h2>
      }
      <hr>
      <mat-form-field appearance="outline">
        <mat-label> {{"division.edit-form-reference" | translate}} </mat-label>
        <input matInput formControlName="reference">
      </mat-form-field>
      <button class="btn btn-success" [disabled]="viewController" (click)="updateDivision()"> {{"division.button-save" |
        translate}} </button>
      <button class="btn btn-danger" [disabled]="viewController" (click)="deleteDivision()"> {{"division.button-delete"
        |
        translate}} </button>
    </div>
    }
  </div>
</div>